import "./Hero.scss";
import Button from "../../components/shared/Button";
import { ArrowRight } from "iconsax-react";
import HeroMonster from "../../assets/images/hero-monster.png";
import HeroDecoration from "../../assets/images/hero-decoration.png";

export default function Hero() {
	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					<img className="decoration hero-decoration shake-slow-3" src={HeroDecoration} alt="hero-decoration" />
					<div className="decoration light light-1" />
					
					<div className="hero-content">
						<h1 className="hero-title" data-aos="fade-up">
							Intelligent Autonomous Precision
						</h1>
						<div className="hero-desc" data-aos="fade-up" data-aos-delay="50">
							Revolutionizing trading, research, and
							decision-making.
						</div>
						<div className="hero-btns" data-aos="fade-up" data-aos-delay="100">
							<Button className="launch-app-btn">
								DAPP
								<ArrowRight className="ms-2" size="20" />
							</Button>
						</div>
					</div>

						<img className="hero-img shake-slow-2" src={HeroMonster} alt="hero-monster" width={615} height={660} />
				</div>
			</div>
		</>
	);
}
